var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "women_4"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#30ACE2"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C2A20"
    },
    d: "M80.123,29.486c0,0-6.885-7.69-17.931-2.771c-7.717,3.438-9.388,5.689-15.975,7.19 c-6.954,1.585-11.612,8.499-8.915,16.635c2.243,6.766,4.136,15.674,2.663,19.479c-1.941,5.016-0.04,8.887,6.606,13.604 c6.647,4.717,17.24,9.335,17.24,9.335l19.281-1.348c0,0,23.688-4.499,21.983-16.622c-1.231-8.745-3.232-9.549,1.196-14.899 c2.838-3.43,2.791-14.756-3.855-18.615c-6.647-3.858-5.928-8.484-9.573-11.7C89.198,26.558,80.123,29.486,80.123,29.486z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M109.374,115.395c-4.963-9.396-36.874-15.292-36.874-15.292s-31.911,5.896-36.874,15.292 C31.957,128.434,28.889,145,28.889,145H72.5h43.611C116.111,145,114.039,127.236,109.374,115.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.5,100.103c0,0,31.911,5.896,36.874,15.292c4.665,11.842,6.737,29.605,6.737,29.605H72.5 V100.103z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.813,
    y: 81.001,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.375,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 81.001,
    style: {
      fill: "#E4B692"
    },
    width: 8.688,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.813,94.475c1.563,4.485,7.869,7.057,12.5,7.057 c1.676,0,3.306-0.28,4.875-0.795V81.001H63.813V94.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.838,62.653c0-18.162-10.001-28.489-22.338-28.489c-12.336,0-22.338,10.327-22.338,28.489 S60.164,95.539,72.5,95.539C84.837,95.539,94.838,80.815,94.838,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M94.838,62.653c0-18.162-10.001-28.489-22.338-28.489v61.375 C84.837,95.539,94.838,80.815,94.838,62.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF0020"
    },
    d: "M109.374,115.395c-1.665-3.152-6.368-5.908-11.877-8.183 c-2.771,11.233-12.909,19.565-24.997,19.565s-22.227-8.332-24.997-19.565c-5.508,2.274-10.212,5.03-11.877,8.183 C31.957,128.434,28.889,145,28.889,145H72.5h43.611C116.111,145,114.039,127.236,109.374,115.395z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9426,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M59.228,103.094 c0,0.012,0,0.023,0,0.034"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9426,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.0651,2.6035"
    },
    d: " M59.48,105.718c1.223,6.252,6.733,10.969,13.344,10.969c7.057,0,12.861-5.378,13.531-12.26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.9426,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M86.42,103.128 c0-0.012,0-0.022,0-0.034"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C2A20"
    },
    d: "M76.234,34.459c-0.398-0.399-19.659-5.292-18.626,5.553c0.798,8.377-5.167,8.045-9.041,14.3 c-3.875,6.256-4.24,10.453-0.47,15.709c0.336-3.947,0.47-9.387,8.846-15.709c8.377-6.321,8.111-9.38,7.047-13.502 C62.927,36.688,76.234,34.459,76.234,34.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#564036"
    },
    d: "M55.481,80.3c-9.767-5.88-8.108-14.849-7.751-19.324c0.421-5.251,5.768-6.877,12.069-10.658 c6.301-3.779,2.082-5.666,4.602-11.967c2.521-6.301,16.541-4.056,16.541-4.056s-8.228,0.061-10.747,6.361 c-2.521,6.302,1.051,8.191-5.251,11.972c-6.301,3.78-9.534,3.77-11.026,8.822C52.367,66.705,48.162,70.637,55.481,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#564036"
    },
    d: "M46.057,72.885c-9.767-5.879-6.239-11.906-5.882-16.382c0.421-5.251,3.863-6.283,10.165-10.063 c6.301-3.78,3.592-4.429,6.113-10.729C58.974,29.41,72.94,33.61,72.94,33.61s-8.821-1.891-11.342,4.41 c-2.521,6.303,0.381,7.252-5.251,11.972c-3.992,3.347-11.319,3.563-11.026,8.822C45.689,65.4,38.285,67.004,46.057,72.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C2A20"
    },
    d: "M69.944,33.927c0.399-0.398,19.66-5.291,18.627,5.554c-0.798,8.377,5.166,8.044,9.041,14.3 c3.875,6.255,4.24,10.453,0.469,15.708c-0.336-3.947-0.469-9.387-8.846-15.708c-8.376-6.322-8.11-9.38-7.047-13.502 C83.253,36.156,69.944,33.927,69.944,33.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#564036"
    },
    d: "M91.525,78.713c9.767-6.405,6.239-12.972,5.882-17.849c-0.421-5.721-3.51-5.759-9.812-9.878 c-6.301-4.118-2.667-5.894-5.188-12.758c-2.521-6.864-17.172-4.431-17.172-4.431s8.227,0.066,10.747,6.931 c2.521,6.866-1.051,8.926,5.251,13.043c6.301,4.119,10.606,3.892,11.026,9.612C92.619,68.26,99.297,72.305,91.525,78.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#564036"
    },
    d: "M100.424,76.874c9.876-6.534,6.309-13.23,5.947-18.204c-0.425-5.835-3.906-6.982-10.279-11.183 c-6.371-4.201-3.631-4.922-6.181-11.923c-2.549-7.002-16.673-2.334-16.673-2.334s8.921-2.101,11.469,4.9 c2.55,7.004-0.385,8.058,5.31,13.304c4.037,3.718,11.447,3.959,11.15,9.803C100.796,68.558,108.282,70.338,100.424,76.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF0020"
    },
    d: "M97.497,107.212c0,0-9.245,3.77-7.813,12.982c-4.951-0.36-15.588,0.762-17.184,6.583 c-3.723-5.17-12.434-7.961-17.651-7.009c-0.076-5.253-3.489-10.641-7.346-12.557c-4.786,9.387-2.046,18.96-2.046,18.96 s12.151,10.238,12.816,10.238c0.665,0,25.661,4.388,25.661,4.388s16.689-5.452,16.788-5.983 C100.821,134.282,97.497,107.212,97.497,107.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#564036"
    },
    d: "M87.993,45.597c0,0,1.792,8.187,10.036,16.088c3.521,3.377,0.798,18.083-6.781,25.396 c6.515-5.318,16.035-16.403,11.833-25.396C98.88,52.692,89.891,49.61,87.993,45.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#564036"
    },
    d: "M60.048,45.016c0,0-2.265,10.496-10.509,18.397c-3.521,3.377-4.405,13.529,3.174,20.842 c-6.516-5.318-12.428-11.849-8.227-20.842C48.688,54.421,58.15,49.029,60.048,45.016z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.42e410d29aa948794d4a201cc80309e5.svg";
export { ForwardRef as ReactComponent };